import builder from '../builder';
import CloudUpload from '../../streamline-icons/light/cloud-upload.svg';

export default builder('IconCloudUploadLight', CloudUpload);
